import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-case-setting-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './case-setting-form.component.html',
  styleUrl: './case-setting-form.component.scss'
})
export class CaseSettingFormComponent implements OnInit {
  @Input() caseSettingForm!: FormGroup;
  @Output() nextStepEvent = new EventEmitter<void>();
  // @Output() formSubmitted = new EventEmitter<any>();
  constructor() { }

  ngOnInit(
  ): void {
    console.log(this.caseSettingForm)
    // Initialization logic can go here
  }

  // Define any methods or properties needed for the component
  onSubmit() {
    // Handle form submission logic
  }
  isControlInvalid(controlName: string): boolean {
    if (this.caseSettingForm) {
      const control = this.caseSettingForm.get(controlName);
      return control
        ? control.invalid && (control.dirty || control.touched)
        : false;
    }
    return false;
  }
  // savePreparation(event: Event): void {
  //   event.preventDefault();
  //   if (this.caseSettingForm) {
  //     if (this.caseSettingForm.valid) {
  //       this.formSubmitted.emit(this.caseSettingForm.value);
  //     } else {
  //       this.caseSettingForm.markAllAsTouched();
  //     }
  //   }
  //   else{
  //     this.caseSettingForm.markAllAsTouched();
  //   }
  // }
  goToNextStep(): void {
    if (this.caseSettingForm.invalid) {
      this.markFormGroupTouched(this.caseSettingForm);
      return;
    }
    this.nextStepEvent.emit();
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
    });
  }
}
